<template>
  <section class="emmaus-wrap py-5">
    <div class="container">

      <!-- Titre -->
      <p class="emmaus-intro text-center mb-5">
        Pour une jeunesse chrétienne adulte, responsable et engagée
      </p>

      <!-- Présentation -->
      <div class="info-box mb-5">
        <p>
          Le <strong>Parcours OMEGA</strong> est une véritable aubaine pour les
          jeunes ayant le niveau <strong>BAC</strong> et jusqu’à
          <strong>25 ans</strong>.
        </p>
        <p>
          Il leur offre des <strong>outils</strong> et des
          <strong>valeurs</strong> pour définir leur idéal de vie, dans une
          tension vers les sommets, les hauteurs et l’excellence.
        </p>
        <p>
          Inspiré par le <strong>Christ, Ami des Jeunes</strong>, l’OMEGA de
          l’histoire humaine, ce parcours se déroule sur
          <strong>deux ans</strong>, à raison de
          <strong>deux week-ends par mois</strong>.
        </p>
      </div>

      <!-- Vision -->
      <h4 class="section-subtitle text-center mb-4">
        Notre vision pour les jeunes
      </h4>

      <div class="row g-4 mb-5">
        <div
          class="col-md-4"
          v-for="(vision, i) in visions"
          :key="i"
        >
          <div class="emmaus-card">
            <div class="emmaus-number">{{ i + 1 }}</div>
            <p>{{ vision }}</p>
          </div>
        </div>
      </div>

      <!-- Objectifs -->
      <div class="section-box mb-5">
        <h4 class="section-subtitle mb-3">
          Un parcours pour
        </h4>
        <ul>
          <li v-for="(obj, i) in objectives" :key="i">
            {{ obj }}
          </li>
        </ul>
      </div>

      <!-- Cours -->
      <div class="section-box mb-5">
        <h4 class="section-subtitle mb-3">
          Des cours de qualité, modulables et à la carte
        </h4>

        <ul>
          <li v-for="(course, i) in courses" :key="i">
            {{ course }}
          </li>
        </ul>

        <p class="mt-3">
          Ces enseignements s’appuient sur la
          <strong>Bible</strong>, la <strong>Théologie</strong> et
          l’<strong>Histoire de l’Église</strong> pour répondre aux grandes
          interrogations des jeunes sur Dieu, la foi et l’engagement chrétien
          dans la cité.
        </p>
      </div>

      <!-- Offre spirituelle -->
      <div class="section-box mb-5">
        <h4 class="section-subtitle mb-3">
          Une offre spirituelle riche
        </h4>
        <ul>
          <li v-for="(spi, i) in spiritualOffer" :key="i">
            {{ spi }}
          </li>
        </ul>
      </div>

      <!-- Accompagnement -->
      <div class="row g-4 mb-5">
        <div class="col-md-6">
          <div class="info-box">
            <h5>Accompagnement de qualité</h5>
            <ul>
              <li>Tutorat & accompagnement institutionnel</li>
              <li>Mentorat : rencontres avec des personnalités inspirantes</li>
            </ul>
          </div>
        </div>

        <div class="col-md-6">
          <div class="info-box">
            <h5>Espaces de culture & d’échanges</h5>
            <p>
              Le parcours OMEGA est un véritable creuset culturel à travers
              colloques, séminaires, journées académiques et espaces de débat.
            </p>
          </div>
        </div>
      </div>

      <!-- Raisons -->
      <div class="section-box mb-5">
        <h4 class="section-subtitle text-center mb-3">
          5 bonnes raisons pour s’inscrire
        </h4>
        <ul>
          <li v-for="(reason, i) in reasons" :key="i">
            {{ reason }}
          </li>
        </ul>
      </div>

      <!-- Coût -->
      <div class="cost-box">
        <h4>Coût de la formation</h4>
        <p>
          <strong>70 000 FCFA par an</strong>,
          payables en <strong>deux tranches</strong>
        </p>
        <p class="mt-2 fw-bold">
          Parcours OMEGA, une aide assurée aux parents quant à l’avenir de leurs enfants.
        </p>
      </div>
      <br><br><br>
       <div class="year-tabs text-center mb-4">
        <button class="year-tab" :class="{ active: activeYear === 1 }" @click="activeYear = 1">1ère année</button>
        <button class="year-tab" :class="{ active: activeYear === 2 }" @click="activeYear = 2">2ème année</button>
      </div>

      <!-- Modules détaillés par année -->
      <div v-for="year in years" :key="year.id" v-show="activeYear === year.id">
        <h4 class="year-title text-center mb-2">{{ year.title }}</h4>
        <p class="year-note text-center mb-4">{{ year.note }}</p>

        <div class="row g-4">
          <div class="col-md-6" v-for="(module, i) in year.modules" :key="i">
            <div class="module-card">
              <h5 class="module-title">{{ module.name }}</h5>
              <ul>
                <li v-for="(course, j) in module.courses" :key="j">{{ course }}</li>
              </ul>
            </div>
          </div>
        </div>
<br><br><br>
        <!-- Tribunes Réussir -->
        <div class="section-box mb-5">
            <h4 class="section-subtitle mb-3 text-center">Tribunes Réussir</h4>
            <ul>
                <li v-for="(tribune, i) in tribunes" :key="i">{{ i + 1 }}. {{ tribune }}</li>
            </ul>
            <p class="mt-2 fst-italic text-center">{{ tribunesNote }}</p>
        </div>
        <div class="text-center">
            <a href="/Depliant.pdf" 
            download="Depliant.pdf"
            class="btn-download me-3">
            Télécharger Dépliant
            </a>
        </div>
      </div>
    </div>
  </section>
</template>
<script lang="ts">
export default {
  name: "ParcoursOmega",
  data() {
    return {
        activeYear: 1,
      visions: [
        "Prendre soin des jeunes face aux opportunités et défis du monde actuel",
        "Allier formation intellectuelle et dimension spirituelle pour une croissance équilibrée",
        "Aider les jeunes à se connecter au Christ, à l’exemple de Jean"
      ],

      objectives: [
        "Éveiller le cœur aux grandes interrogations de la vie",
        "Faire rencontrer le Christ dans la Parole et l’Eucharistie",
        "Sensibiliser aux enjeux de la cité à partir de la foi",
        "Former des Témoins et des Leaders chrétiens"
      ],

      courses: [
        "Être jeune aujourd’hui en Afrique",
        "Amitié, Amour, Corps et Sexualité",
        "Prendre la parole en public",
        "Devenir leader",
        "Foi chrétienne, Église et engagement dans la société"
      ],

      spiritualOffer: [
        "Sorties spirituelles entre jeunes",
        "Adoration mensuelle",
        "Parcours spirituel et retraites",
        "Pèlerinage annuel « Aux Sources de la foi »"
      ],

      reasons: [
        "Donner un sens à sa vie par une relation plus profonde avec le Christ",
        "Mieux connaître sa foi et ses implications",
        "Découvrir et aimer l’Église du Seigneur et la servir",
        "Disposer de repères fiables face aux mutations sociales",
        "Devenir un jeune leader chrétien engagé dans la transformation de la société"
      ],
      
      years: [
  {
    id: 1,
    title: "1ère année – Liste détaillée des cours",
    note: "Certains cours sont donnés en mode cyclique avec la 2ème année",
    cost: "140 000 FCFA (hors activités)",
    modules: [
      {
        activeYear: 2,
        name: "Bible",
        courses: [
          "LA BIBLE, PAROLE DE DIEU ET PAROLES D’HOMMES : Découvrir la Bible, en quoi elle est à la fois œuvre de Dieu et des hommes et son importance pour le Chrétien, disciple de la parole (étude d’un texte biblique)",
          "LES PSAUMES : PAROLES MAGIQUES OU PAROLES DE FOI ? : Qu’est-ce que les psaumes ? Existe-t-il la clé des psaumes ? La relecture chrétienne des psaumes",
          "INTRODUCTION AUX PROPHETES : Qui est le prophète ? Pourquoi être prophète ? Quels sont les grands thèmes touchés par les prophètes ? Comment être prophète aujourd’hui ? Étude d’un prophète jeune"
        ]
      },
      {
        name: "Théologie",
        courses: [
          "INTRODUCTION A LA THEOLOGIE : Indiquer comment la foi s’intègre à toutes les dimensions de la vie à laquelle elle donne sens (définition, son rapport à la raison et à la culture)",
          "ET DIEU CREA LE CIEL ET LA TERRE : Souligner la spécificité des récits bibliques de création et leur rapport aux découvertes scientifiques et fonder un environnement",
          "LE MYSTERE DE DIEU : Découvrir la présence de Dieu dans le monde et dans sa parole et avoir les outils pour affronter les pathologies de la religion et de la raison",
          "Le mystère de Dieu Un et Trine : Découvrir à partir de la Parole de Dieu le mystère de la Trinité et ses implications pour la vie de foi"
        ]
      },
      {
        name: "Histoire de l’Église",
        courses: [
          "L’Église en fondation et l’Église définit sa foi (Siècles I – III & IV – IX)"
        ]
      },
      {
        name: "Vie de foi",
        courses: [
          "Liturgie : Grands repères liturgiques : Comprendre la liturgie à travers ses rites et son organisation (couleurs et temps liturgiques ; calendrier liturgique) comme un acte de foi",
          "Spiritualité : Apprendre à prier comme chrétien (spécificité de la prière chrétienne) à partir de la Parole de Dieu (Lectio divina)",
          "Morale : Principes de la morale chrétienne et Principes fondamentaux de la Doctrine Sociale de l’Église – établir le lien entre foi et morale dans la vie personnelle et sociale"
        ]
      },
      {
        name: "Culture générale",
        courses: [
          "La grâce d’être jeune : Amitié et Amour – Se connaître comme jeune, découvrir sa valeur en évitant les pièges relatifs à cet âge (à partir des Écritures et de la vie)",
          "Être jeune et leader – Pour une prise de conscience de l’engagement et un bon usage des moyens de communication",
          "Analyse des racines culturelles et historiques de la crise africaine – Des réflexes et outils pour apprécier quelques défis de l’Afrique (culture, esclavage, colonisation)",
          "Méthodologie de travail et de recherche – Savoir formuler, poser et analyser un problème, au regard des défis africains"
        ]
      }
    ]
  },
  {
    id: 2,
    title: "2ème année – Liste détaillée des cours",
    note: "Certains cours sont donnés en mode cyclique avec la 1ère année",
    cost: "140 000 FCFA",
    modules: [
      {
        name: "Bible",
        courses: [
          "Les Évangiles : Comment les Évangiles ont-ils été rédigés ? Toutes les paroles de l’Évangile ont-elles été dites par le Christ ? Y-a-t-il des évangiles cachés ?",
          "Les Actes et l’œuvre de l’apôtre Paul : Comment vivaient les premiers chrétiens ? Paul est-il le fondateur du Christianisme ?",
          "L’Apocalypse : Dieu a-t-il déjà prévu d’avance le nombre des sauvés ? La fin du monde est-elle pour bientôt ? À la fin des temps, est-ce seulement les chrétiens qui seront sauvés ?"
        ]
      },
      {
        name: "Théologie",
        courses: [
          "Le mystère de Jésus, vrai Dieu et vrai homme : Jésus a-t-il vraiment existé ? Jésus est-il vraiment Dieu ? Comment peut-on être Dieu et homme ? Jésus n’est-Il pas un prophète comme Mahomet ou Bouddha ?",
          "L’Esprit-Saint, l’Église et Marie : Jésus a-t-Il jamais fondé une Église ? Jésus étant le Sauveur, avons-nous encore besoin du Saint Esprit ? Marie n’a-t-elle pas eu d’autres enfants après Jésus ?",
          "Grâce et Eucharistie : En s’appuyant sur sa bonne volonté, l’homme ne peut-il pas devenir meilleur et changer le monde ? Faire de l’Eucharistie le corps et le sang de Jésus n’est-ce pas de l’idolâtrie ?",
          "Les fins dernières et le temps présent : Le Purgatoire n’est-il pas une invention ? Le monde aura-t-il vraiment une fin et en quoi consistera-t-elle ? Sur quoi Dieu va-t-il nous juger ? Si Dieu est amour, pourquoi l’enfer ?"
        ]
      },
      {
        name: "Histoire de l’Église",
        courses: [
          "L’Église se réforme (Siècles X-XVIII)",
          "L’Église en mission (Siècles XIX – à nos jours) : Comment sont apparus les Protestants et les Anglicans ?"
        ]
      },
      {
        name: "Vie de foi",
        courses: [
          "Spiritualité : Étude de la vie d’un saint (Martyrs de l’Ouganda, Bx Carlo ACUTIS, Sainte Thérèse de Lisieux) – Un jeune peut-il devenir saint ? Comment être jeune aujourd’hui et devenir saint ? Peut-on avoir des saints africains aujourd’hui ?",
          "Morale : Avortement et contraceptifs – Pour limiter la pauvreté en Afrique, la contraception n’est-elle pas un moyen efficace ? Si l’État autorise l’avortement, en quoi l’Église peut-elle le refuser ?"
        ]
      },
      {
        name: "Culture générale",
        courses: [
          "Prendre la parole en public (méthodologie de l’art oratoire) : Comment défendre son point de vue et convaincre efficacement ?",
          "Le chrétien dans la cité : La foi chrétienne détourne-t-elle des enjeux terrestres ? L’engagement chrétien",
          "Grandes tendances : l’incompatibilité des cercles ésotériques avec le bonheur de l’homme – Peut-on avoir de l’argent à tout prix ? Pour mon bonheur, puis-je rentrer dans la franc-maçonnerie ?",
          "Méthodologie de travail et de recherche – Travailler avec méthode, c’est réussir ses études et sa vie"
        ]
      }
    ]
  }
],
    tribunes: [
    "Réussir dans le monde socio-politique",
    "Réussir malgré les obstacles",
    "Réussir une activité",
    "Réussir son projet (avec la dimension : avec Dieu)",
    "Réussir sa sexualité",
    "Réussir dans une société connectée (gestion du temps et de la place des réseaux sociaux, discernement du virtuel et de la réalité, impasse de la désinformation et de la manipulation)",
    "Réussir sa vie (il n'y a pas de réussite sans souffrance)"
    ],
    tribunesNote: "NB : Les tribunes libres se font en tandem avec les jours d’adoration eucharistique."

    }
  }
}
</script>
<style scoped>
.emmaus-wrap {
  background: #f8f9fa;
}

.emmaus-title {
  color: #0b1b3f;
  font-weight: 800;
}

.emmaus-intro {
  color: #6c757d;
}

.section-subtitle {
  color: #0b1b3f;
  font-weight: 700;
}

.emmaus-card {
  background: white;
  padding: 25px;
  border-radius: 16px;
  box-shadow: 0 6px 20px rgba(0,0,0,0.08);
  text-align: center;
}

.emmaus-number {
  width: 45px;
  height: 45px;
  background: #ffc107;
  color: #0b1b3f;
  font-weight: 800;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
}

.section-box {
  background: white;
  padding: 30px;
  border-radius: 16px;
  box-shadow: 0 6px 18px rgba(0,0,0,0.08);
}

.info-box {
  background: white;
  padding: 22px;
  border-radius: 14px;
  border-left: 6px solid #0b1b3f;
}

.cost-box {
  background: white;
  border-left: 6px solid #ffc107;
  padding: 25px;
  border-radius: 14px;
  max-width: 800px;
  margin: auto;
  text-align: center;
}

.year-tabs { display: flex; justify-content: center; gap: 15px; margin-bottom: 20px; }
.year-tab { padding: 10px 25px; border-radius: 25px; border: 2px solid #0b1b3f; background: transparent; font-weight: 700; color: #0b1b3f; cursor: pointer; }
.year-tab.active { background: #ffc107; border-color: #ffc107; }
.module-card { background: white; padding: 22px; border-radius: 14px; box-shadow: 0 6px 18px rgba(0,0,0,0.08); height: 100%; }
.module-title { color: #0b1b3f; font-weight: 700; margin-bottom: 10px; }

.section-box ul li {
  margin-bottom: 10px;
  line-height: 1.6;
}
.fst-italic {
  font-style: italic;
  color: #6c757d;
}

.btn-download {
  background: #ffc107;
  color: #0b1b3f;
  font-weight: 700;
  padding: 12px 26px;
  border-radius: 10px;
  text-decoration: none;
  transition: all 0.3s ease;
}

.btn-download:hover {
  background: #e0a800;
  transform: translateY(-2px);
}

</style>
